import IBaseVendorGameConfig from '../core/src/managers/contracts/configurations/game/IBaseVendorGameConfig';
import IGameGeneralConfig from '../core/src/managers/contracts/configurations/IGeneralGameConfig';
import IVendorClientConfigRequestData from '../server/requests/contracts/IVendorClientConfigRequestData';
import AbstractGameGeneralConfig from '../core/src/baseConfigs/AbstractGameGeneralConfig';
import ConfigManager from '../core/src/managers/ConfigManager';
import { ConfigurationTypes } from '../core/src/const/ConfigurationTypes';
export default abstract class AbstractVendorGameGeneralConfig extends AbstractGameGeneralConfig implements IGameGeneralConfig<IVendorClientConfigRequestData>, IBaseVendorGameConfig {
  private _clientConfig: IVendorClientConfigRequestData;
  private defaultRTP: number = 96.59;
  get clientConfig(): IVendorClientConfigRequestData {
    return this._clientConfig
  };
  parseClientConfig(data: IVendorClientConfigRequestData) {
    this._clientConfig = {...this._clientConfig, ...data};
  }
  getRTP(forFeature?: boolean): number {
    let result: number;
    if (this.clientConfig?.gameDetails?.RTP) {
      result = this.clientConfig.gameDetails.RTP
    } else {
      if (ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId === "starpops_90") {
        result = 90;
      } else {
        result = this.defaultRTP
      }
    }

    if (forFeature) {
      if (result >= 95 && result <= 98) {
        result = 96.52;
      } else if (result >= 89 && result <= 91) {
        result = 90.21
      }
    }

    return result;
  }
}
